import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import RichText from '../../../Core/RichText';

import {
  StyledListItem,
  CardImage,
  ImgWrapper,
  StyledLink,
  Content,
  Author,
} from './styles';

const BlogCard = ({ data = null }) => {
  if (!data) return null;

  const { ariaLabel, headline, imageDam, pageSlug, articleAuthor } = data;
  const updatedPageSlug = `/learning-hub/blog/${pageSlug}/`;

  const intl = useIntl();

  // eslint-disable-next-line no-nested-ternary
  const ariaText = ariaLabel
    ? intl.locale === 'en'
      ? `Read blog article: ${ariaLabel}`
      : `Lire article du blog : ${ariaLabel}`
    : intl.locale === 'en'
      ? `Read blog article`
      : `Lire article du blog`;

  const updatedData = {
    ...data,
    ...{ links: updatedPageSlug },
    ...{ ariaLabel: ariaText },
    ...{ analyticLocation: 'blog-section' },
  };

  return (
    <StyledListItem role="listitem">
      <StyledLink className="unstyled-link" data={updatedData}>
        <ImgWrapper>
          {imageDam && <CardImage src={imageDam} objectFit="cover" />}
        </ImgWrapper>
        <Content>
          {headline && <RichText document={headline} />}
          {articleAuthor && <Author>{articleAuthor}</Author>}
        </Content>
      </StyledLink>
    </StyledListItem>
  );
};

BlogCard.propTypes = {
  data: PropTypes.shape(),
};

export default BlogCard;
